<main class="container-fluid">
  <div class="side-bar" *ngIf="organization">
    <div class="logo">
      <img src="{{ organization.picture || 'assets/img/profile-picture.png' }}" alt="Organisatie logo">
    </div>
    <h1 class="mt-3 subtitle mb-1">{{ organization.name }}</h1>
    <p class="org-text fs-6 mb-1">Welkom bij jouw dashboard!</p>
    <p class="org-text fs-6" *ngIf="user">Gebruiker sinds {{ user.created | slice:6:10  }}</p>
  </div>
  <div class="org-container gap-3">
    <div class="w-100" *ngIf="organization">
      <h1 class="subtitle">Mijn Organisatie</h1>
      <table class="org-details">
        <tr>
          <td class="org-text">Naam contactpersoon</td>
          <td>{{ organization.contactName }}</td>
        </tr>
        <tr>
          <td class="org-text">Telefoonnummer contactpersoon</td>
          <td>{{ organization.contactPhone }}</td>
        </tr>
        <tr>
          <td class="org-text">E-mailadres organisatie</td>
          <td>{{ organization.email }}</td>
        </tr>
        <tr>
          <td class="org-text">Adres</td>
          <td>{{ organization.street }} {{ organization.houseNumber }} {{ organization.zipcode }} {{ organization.city }}</td>
        </tr>
        <tr>
          <td class="org-text">Beschrijving</td>
          <td>{{ organization.description }}</td>
        </tr>
      </table>
      <div class="row button-row">
        <button class="btn btn-primary org-button mt-3" routerLink="/mijn-organisatie/gegevens">
          Organisatiegegevens wijzigen
        </button>
      </div>
      <div class="row button-row">
        <button class="btn btn-primary org-button mt-3" routerLink="/mijn-organisatie/gegevens/adres-wijzigen">
          Adresgegevens wijzigen
        </button>
      </div>
      <div class="row button-row">
        <button class="btn btn-primary org-button mt-3" routerLink="/mijn-organisatie/gegevens/contact-wijzigen">
          Contactgegevens wijzigen
        </button>
      </div>
      <div class="row button-row">
        <button class="btn btn-primary org-button mt-3" routerLink="/mijn-organisatie/gegevens/email-wijzigen">
          E-mailadres wijzigen
        </button>
      </div>
    </div>
    <h2 class="subtitle mt-5">Activiteiten</h2>
    <div class="org-activities">
      <h2 class="subtitle mt-5">{{ eventCounter }} Activiteit(en)</h2>
      <p>Je hebt momenteel <b>{{ eventCounter }}</b> activiteit(en) gepland</p>
      <div class="row justify-content-center">
        <button class="btn btn-primary org-button mt-2" routerLink="/mijn-organisatie/activiteiten">
          Activiteit plaatsen
        </button>
      </div>
      <div class="row justify-content-center">
        <button class="btn btn-primary org-button mt-2" routerLink="/mijn-organisatie/activiteiten">
          Bekijken & aanpassen
        </button>
      </div>
    </div>
  </div>
</main>
